import { ArrowUpRight } from "@phosphor-icons/react";
import useReveal from "../../hooks/useReveal";

import "./projects.scss";

export default function ProjectCard({ name, description, link, stat, statLabel, meta }) {
  const [ref, , cls] = useReveal({ threshold: 0.3 });
  return (
    <li className={`project ${cls}`} ref={ref}>
      <a href={link} target="_blank" rel="noreferrer" draggable="false">
        <div className="project-text">
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
        <div className="project-stat">
          {stat ? (
            <>
              <span className="project-stat-value">{stat}</span>
              <span className="label">{statLabel}</span>
            </>
          ) : (
            <span className="label">{meta}</span>
          )}
        </div>
        <span className="project-arrow" aria-hidden="true">
          <ArrowUpRight size={18} weight="bold" />
        </span>
      </a>
    </li>
  );
}
